<template lang="html">
  <v-container fluid>
    <public-create-booking
      ref="pcb"
      style="max-width: 500px;"
      class="mx-auto"
      :default-item="defaultItem"
      :calendar-id="calendarId"
      :on-create="onCreate"
      :ok-for-availability="validInput"
    >

      <template v-slot:date-time-form:prepend="{item}">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Guests"
              v-model="item.guests"
              @input="onInput"
              type="tel"
              autocomplete="off"
              :rules="[required, validNumber]"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Whereof children"
              v-model="item.guests_children"
              @input="onInput"
              type="tel"
              autocomplete="off"
              :rules="[required, validNumber, (v) => !v || Number(v) < Number(item.guests) || 'Must be less than number of guests']"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:summary="{item}">
        <div class="mb-2">
          <span class="text--secondary">Guests:</span><br/>
          {{item.guests}} guests, whereof {{item.guests - item.guests_children}} adults {{0 >= item.guests_children ? '' : `and ${item.guests_children} children`}}
        </div>
      </template>

    </public-create-booking>
  </v-container>
</template>

<script>
import {PublicCreateBooking} from 'dync-booking'

export default {
  props: {
    calendarId: {}
  },
  data() {
    return {
      defaultItem: {
        guests_children: 0,
        contact: {}
      }
    };
  },
  methods: {
    required: (v) => (v != null && v !== '') || 'Required',
    validNumber: (v) => !v || Number(v) == v || 'Invalid number',
    onInput(value) {
      if (this.$refs.pcb) {
        this.$refs.pcb.onInput(value);
      }
    },
    onCreate(item) {
      this.$set(item, 'guests', Number(item.guests));
      this.$set(item, 'guests_children', Number(item.guests_children));
      var resourceDemands = [
        {
          title: 'Tables',
          demands: [
            {
              type: 'resource_value',
              property: 'type',
              value: 'table'
            },
            {
              type: 'resources_min_value',
              property: 'seats',
              value: item.guests
            }
          ]
        }
      ];
      this.$set(item, 'resources', resourceDemands);
    },
    validInput(date, item) {
      if (
        this.required(date) === true
        && this.required(item.guests) === true
        && this.validNumber(item.guests) === true
        && this.required(item.guests_children) === true
        && this.validNumber(item.guests_children) === true
      ) {
        return true;
      }
      return false;
    }
  },
  components: {
    PublicCreateBooking
  }
}
</script>

<style lang="scss" scoped>
</style>
